var uo = Object.defineProperty, po = Object.defineProperties;
var mo = Object.getOwnPropertyDescriptors;
var x = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, B = Object.prototype.propertyIsEnumerable;
var M = (i, c, u) => c in i ? uo(i, c, { enumerable: !0, configurable: !0, writable: !0, value: u }) : i[c] = u, t = (i, c) => {
  for (var u in c || (c = {}))
    A.call(c, u) && M(i, u, c[u]);
  if (x)
    for (var u of x(c))
      B.call(c, u) && M(i, u, c[u]);
  return i;
}, d = (i, c) => po(i, mo(c));
var E = (i, c) => {
  var u = {};
  for (var f in i)
    A.call(i, f) && c.indexOf(f) < 0 && (u[f] = i[f]);
  if (i != null && x)
    for (var f of x(i))
      c.indexOf(f) < 0 && B.call(i, f) && (u[f] = i[f]);
  return u;
};
import { jsxs as fo, jsx as O } from "react/jsx-runtime";
import a from "../../../node_modules/prop-types/index.es.js";
import lo, { useState as go, useMemo as W, useEffect as bo } from "react";
import ho from "react-select";
import xo from "react-select/async";
import vo from "react-select/async-creatable";
import So from "react-select/creatable";
import { fontSizes as Co } from "../constants.es.js";
import { Select as wo } from "./style.es.js";
import { CreateLabel as Io } from "./components/CreateLabel.es.js";
import { Option as To } from "./components/Option.es.js";
import { Control as Oo } from "./components/Control.es.js";
import { DropdownIndicator as _o } from "./components/DropdownIndicator.es.js";
import { MultiValue as zo } from "./components/MultiValue.es.js";
import { ValueContainer as Lo } from "./components/ValueContainer.es.js";
import { Menu as No } from "./components/Menu.es.js";
import { MenuList as Vo } from "./components/MenuList.es.js";
import { Placeholder as jo } from "./components/Placeholder.es.js";
import { Z_INDEX as D } from "../../../constants/zIndex.es.js";
import { INPUT_VARIANT as z } from "../../../constants/inputVariant.es.js";
import { Helper as Po } from "../../DataDisplay/Helper/Helper.es.js";
import { COMPONENT_SIZE as ko } from "../../../constants/sizes.es.js";
const _ = {
  sm: "var(--size-components-input-height-sm)",
  md: "var(--size-components-input-height-md)",
  lg: "var(--size-components-input-height-lg)"
}, $ = lo.forwardRef((Ho, eo) => {
  var H = Ho, {
    async: i = !1,
    block: c = !0,
    components: u = {},
    controlWidth: f = "max-content",
    creatable: v = !0,
    createNewText: Z = "Create new option:",
    disabled: b = !1,
    editable: q = !1,
    error: S = !1,
    hasMenuSearch: F = !1,
    helperText: U,
    hideSelectedOptions: X = !1,
    isClearable: G = !1,
    isMulti: L = !1,
    menuPortalTarget: J,
    menuPosition: N,
    menuWidth: V = "100%",
    onApply: h,
    onBlur: j,
    onCancel: P,
    onChange: K,
    onInputChange: k,
    options: Q,
    placeholder: Y = "Filter",
    searchPlaceholder: y = "Search",
    selectedOption: R,
    showSelectedOptionInPlaceholder: C = !0,
    simple: s = !0,
    size: l = ko.md,
    styles: o = {},
    success: w = !1,
    variant: oo = z.outlined,
    parentRef: ro,
    inputProps: I = {
      maxLength: 100
    }
  } = H, no = E(H, [
    "async",
    "block",
    "components",
    "controlWidth",
    "creatable",
    "createNewText",
    "disabled",
    "editable",
    "error",
    "hasMenuSearch",
    "helperText",
    "hideSelectedOptions",
    "isClearable",
    "isMulti",
    "menuPortalTarget",
    "menuPosition",
    "menuWidth",
    "onApply",
    "onBlur",
    "onCancel",
    "onChange",
    "onInputChange",
    "options",
    "placeholder",
    "searchPlaceholder",
    "selectedOption",
    "showSelectedOptionInPlaceholder",
    "simple",
    "size",
    "styles",
    "success",
    "variant",
    "parentRef",
    "inputProps"
  ]);
  const [T, ao] = go(""), to = W(() => v && i ? vo : i ? xo : v ? So : ho, [i, v]), io = (m, n) => m.filter((e) => e.options ? e.options.filter((r) => n.filter((p) => p.value === r.value).length > 0).length > 0 : n.filter((r) => r.value === e.value).length > 0).length > 0, co = W(() => {
    const m = Co[l];
    return d(t({}, o), {
      menuPortal: (n, e) => {
        var r;
        return t(d(t({}, n), {
          zIndex: D.dropdown
        }), ((r = o == null ? void 0 : o.menuPortal) == null ? void 0 : r.call(o, n, e)) || {});
      },
      option: (n, e) => {
        var p;
        let r = {};
        return e.data.__isNew__ && (r = {
          background: "transparent",
          "&:hover": {
            background: "transparent"
          }
        }), t(t(d(t({}, n), {
          fontSize: m,
          color: "var(--color-fg-default)",
          borderRadius: "var(--size-components-input-border-radius-md)",
          background: e.isSelected ? "var(--color-bg-weaker)" : "var(--color-components-input-bg-default)",
          padding: "0 6px",
          textAlign: "left",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          cursor: b ? "not-allowed" : "pointer",
          height: e.data.__isNew__ ? "auto" : "36px",
          marginBottom: "4px",
          "&:hover": {
            backgroundColor: "var(--color-bg-weakest)"
          }
        }), r), (p = o == null ? void 0 : o.option) == null ? void 0 : p.call(o, n, e));
      },
      valueContainer: (n, e) => {
        var r;
        return t(d(t({}, n), {
          padding: 0,
          paddingLeft: `calc(${_[l]} / 2.5)`,
          color: "var(--color-components-input-fg-strong)",
          fontSize: m,
          overflow: "unset",
          gap: "4px",
          display: "flex",
          position: "unset"
        }), ((r = o == null ? void 0 : o.valueContainer) == null ? void 0 : r.call(o, n, e)) || {});
      },
      menu: (n, e) => {
        var r;
        return t(d(t({}, n), {
          width: V,
          color: "var(--color-fg-default)",
          border: "1px solid var(--color-components-input-border-default)",
          boxShadow: "none",
          borderRadius: "var(--size-components-input-border-radius-md)",
          marginTop: 4,
          zIndex: D.dropdown
        }), ((r = o == null ? void 0 : o.menu) == null ? void 0 : r.call(o, n, e)) || {});
      },
      // border-radius: var(--size-components-input-border-radius-md);
      // border: 1px solid var(--color-components-input-border-default);
      // background: var(--color-components-input-bg-default);
      control: (n, e) => {
        var g;
        const r = io(e.options, e.getValue());
        let p = {};
        return (e.menuIsOpen || r && !C) && (p = {
          border: "1px solid var(--color-accent-primary-default)",
          boxShadow: "none",
          "&:hover": {
            borderColor: "var(--color-accent-primary-strong)"
          }
        }), w && (p = {
          border: "1px solid var(--color-accent-primary-default)",
          "&:hover": {
            borderColor: "var(--color-accent-primary-strong)"
          }
        }), S && (p = {
          border: "1px solid var(--color-error-default)",
          "&:hover": {
            borderColor: "var(--color-error-strong)"
          }
        }), t(t(d(t({}, n), {
          display: "flex",
          border: "1px solid var(--color-components-input-border-default)",
          color: "var(--color-components-input-fg-default)",
          backgroundColor: "var(--color-components-input-bg-default)",
          minHeight: _[l],
          height: _[l],
          outline: "none",
          borderRadius: "var(--size-components-input-border-radius-md)",
          padding: "0",
          minWidth: f,
          cursor: b ? "not-allowed" : "pointer",
          boxShadow: "none",
          position: "relative",
          "&:hover": {
            borderColor: "var(--color-components-input-border-strong)"
          }
        }), p), ((g = o == null ? void 0 : o.control) == null ? void 0 : g.call(o, n, e)) || {});
      },
      placeholder: (n, e) => {
        var p;
        const r = {};
        return w && (r.color = "var(--color-accent-primary-default)"), S && (r.color = "var(--color-error-default)"), t(t({
          color: "var(--color-components-input-fg-default)",
          fontSize: m,
          fontWeight: 400,
          zIndex: 2
        }, r), ((p = o == null ? void 0 : o.placeholder) == null ? void 0 : p.call(o, n, e)) || {});
      },
      input: (n, e) => {
        var g;
        let r = {};
        const p = e.selectProps.inputValue;
        return oo === z.filled && p && (r = {
          paddingTop: "14px"
        }), t(t(t({}, n), r), ((g = o == null ? void 0 : o.input) == null ? void 0 : g.call(o, n, e)) || {});
      },
      menuList: (n, e) => {
        var r;
        return t(d(t({}, n), {
          maxHeight: 245,
          padding: 8
        }), ((r = o == null ? void 0 : o.menuList) == null ? void 0 : r.call(o, n, e)) || {});
      },
      dropdownIndicator: (n, e) => {
        var r;
        return t(d(t({}, n), {
          padding: "0 8px 0 4px",
          color: "var(--color-components-input-fg-default)"
        }), ((r = o == null ? void 0 : o.dropdownIndicator) == null ? void 0 : r.call(o, n, e)) || {});
      },
      clearIndicator: (n, e) => {
        var r;
        return t(d(t({}, n), {
          padding: "0 4px 0 8px",
          color: "var(--color-components-input-fg-default)"
        }), ((r = o == null ? void 0 : o.clearIndicator) == null ? void 0 : r.call(o, n, e)) || {});
      },
      indicatorsContainer: (n, e) => {
        var r;
        return t(t({}, n), ((r = o == null ? void 0 : o.indicatorsContainer) == null ? void 0 : r.call(o, n, e)) || {});
      },
      groupHeading: (n, e) => {
        var r;
        return t(d(t({}, n), {
          fontWeight: 700,
          fontSize: m,
          textTransform: "capitalize",
          color: "var(--color-components-input-fg-default)",
          marginBottom: 8,
          marginLeft: 0,
          paddingLeft: 8
        }), ((r = o == null ? void 0 : o.groupHeading) == null ? void 0 : r.call(o, n, e)) || {});
      }
    });
  }, [o, V]);
  return bo(() => {
    k && k(T);
  }, [T]), /* @__PURE__ */ fo(wo, { block: c, disabled: b, children: [
    /* @__PURE__ */ O(to, t({ ref: eo, styles: co, classNamePrefix: "react-select", defaultValue: R, value: R, placeholder: Y, showSelectedOptionInPlaceholder: C, hideSelectedOptions: X, hasMenuSearch: F, options: Q, formatCreateLabel: (m) => /* @__PURE__ */ O(Io, { value: m, createNewText: Z }), isClearable: G, closeMenuOnSelect: !L && !h, controlShouldRenderValue: C, onBlur: (m) => {
      j && j(m);
    }, onChange: K, onInputChange: (m) => {
      m.length <= (I == null ? void 0 : I.maxLength) && ao(m);
    }, isMulti: L, isDisabled: b, components: t({
      IndicatorSeparator: () => null,
      Input: () => null,
      Option: To,
      Control: Oo,
      DropdownIndicator: _o,
      MultiValue: zo,
      ValueContainer: Lo,
      Menu: No,
      MenuList: Vo,
      Placeholder: jo
    }, u), menuPortalTarget: J || N === "absolute" ? null : document.body, menuPosition: N, menuPlacement: "bottom", menuHorizontalPlacement: "auto", appliable: !!h, editable: q, inputValue: T, onCancel: () => {
      P && P();
    }, onApply: () => {
      h && h();
    }, parentRef: ro, searchPlaceholder: y, simple: s }, no)),
    /* @__PURE__ */ O(Po, { text: U, error: S, size: l, success: w })
  ] });
}), Ro = {
  async: a.bool,
  block: a.bool,
  components: a.object,
  controlWidth: a.string,
  creatable: a.bool,
  createNewText: a.string,
  disabled: a.bool,
  editable: a.bool,
  error: a.bool,
  hasMenuSearch: a.bool,
  helperText: a.string,
  hideSelectedOptions: a.bool,
  isClearable: a.bool,
  isMulti: a.bool,
  menuPortalTarget: a.any,
  menuWidth: a.string,
  onApply: a.func,
  onBlur: a.func,
  onCancel: a.func,
  onChange: a.func,
  onInputChange: a.func,
  options: a.array.isRequired,
  placeholder: a.oneOfType([a.node, a.string]),
  searchPlaceholder: a.string,
  selectedOption: a.any,
  showSelectedOptionInPlaceholder: a.bool,
  simple: a.bool,
  styles: a.object,
  success: a.bool,
  variant: a.oneOf(Object.values(z)),
  inputProps: a.object
};
$.displayName = "Select";
$.propTypes = Ro;
export {
  $ as Select,
  Ro as selectPropTypes
};
//# sourceMappingURL=Select.es.js.map
